import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { useLayout } from "../../context/LayoutContext";
import { getUsername } from "../../services/users/AuthService";
import Logo from "../../assets/homepage_logo.png";
import HomeIcon from "../../assets/add.png";
import BudgetIcon from "../../assets/budget.png";
import ServiceIcon from "../../assets/service.png";
import DocumentIcon from "../../assets/document.png";
import UserListIcon from "../../assets/user-list.png";
import "../../css/HomePage.css";

// `titleKey`/`descriptionKey` are i18next translation keys, resolved via
// t(key) at render time.
const QUICK_ACTIONS = [
  {
    titleKey: "homepage.newBudgetTitle",
    descriptionKey: "homepage.newBudgetDescription",
    icon: HomeIcon,
    link: "/create-new-budget",
    accent: true,
  },
  {
    titleKey: "homepage.budgetsTitle",
    descriptionKey: "homepage.budgetsDescription",
    icon: BudgetIcon,
    link: "/budgets",
  },
  {
    titleKey: "homepage.deaeratorsPhcTitle",
    descriptionKey: "homepage.deaeratorsPhcDescription",
    icon: ServiceIcon,
    link: "/deaerators-phc",
  },
  {
    titleKey: "homepage.gestraPricesTitle",
    descriptionKey: "homepage.gestraPricesDescription",
    icon: DocumentIcon,
    link: "/gestra-price-table",
  },
  {
    titleKey: "homepage.spiraxSarcoPricesTitle",
    descriptionKey: "homepage.spiraxSarcoPricesDescription",
    icon: DocumentIcon,
    link: "/spirax-sarco-price-table",
  },
  {
    titleKey: "homepage.userManagementTitle",
    descriptionKey: "homepage.userManagementDescription",
    icon: UserListIcon,
    link: "/users",
  },
];

const HomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { openTab } = useLayout();
  const username = getUsername();

  const handleOpen = (action) => {
    openTab(t(action.titleKey), action.link);
    navigate(action.link);
  };

  return (
    <div className="homepage-container">
      <div className="homepage-header">
        <img src={Logo} alt="Logo da Aplicação" className="homepage-logo" />
        <Typography variant="h4" className="homepage-title">
          {username ? t("homepage.welcomeBack", { username }) : t("homepage.welcome")}
        </Typography>
        <Typography variant="body1" className="homepage-subtitle">
          {t("homepage.subtitle")}
        </Typography>
      </div>

      <div className="homepage-actions">
        {QUICK_ACTIONS.map((action) => (
          <Card
            key={action.link}
            variant="outlined"
            className={`homepage-card ${action.accent ? "accent" : ""}`}
          >
            <CardActionArea
              onClick={() => handleOpen(action)}
              className="homepage-card-action"
            >
              <CardContent className="homepage-card-content">
                <img src={action.icon} alt="" className="homepage-card-icon" />
                <div>
                  <Typography variant="subtitle1" className="homepage-card-title">
                    {t(action.titleKey)}
                  </Typography>
                  <Typography variant="body2" className="homepage-card-description">
                    {t(action.descriptionKey)}
                  </Typography>
                </div>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
